import { getApp, getApps, initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { publicConfig } from '@/config/publicConfig'
import { firebaseConfig } from '@/configs/firebase'

export const firebaseApp = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)

export const firebaseAuth = getAuth(firebaseApp)
firebaseAuth.tenantId = publicConfig.firebase.tenantId
